import http from 'plugins/axios';

export default {
  userRiskFlagList(data) {
    return http.post({
      // url: '/admin/riskQuery/userRiskFlagList',
      url:'/admin/riskQuery/userRiskInfoByIds',
      data
    });
  },
  getInviteRewards(data) {
    return http.get({
      url: '/admin/workorder/findByUse/inviteRewards',
      data
    });
  },
  getAuditList(data) {
    return http.get({
      url: '/admin/workorder/search_withdraw',
      data
    });
  },
  approveAudit(id) {
    return http.post({
      url: '/admin/workorder/approve_withdraw',
      data: { id },
      dataType: 'form'
    });
  },
  reApproveAudit(id) {
    return http.post({
      url: '/admin/workorder/re_approve_withdraw',
      data: { id },
      dataType: 'form'
    });
  },
  approveHand(id) {
    return http.post({
      url: '/admin/workorder/approve_withdraw_manually',
      data: { id },
      dataType: 'form'
    });
  },
  retryWithdrawal(id) {
    return http.post({
      url: '/admin/workorder/retry_withdraw',
      data: { id },
      dataType: 'form'
    });
  },
  setToErrList(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  cancelAudit(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getUserRecords(data) {
    return http.get({
      url: '/admin/workorder/findByUse/Forward',
      data: {
        useId: data.userId,
        page: data.page,
        size: data.size
      }
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/admin/bill/types'
    });
  },
  updateFreeze(id) {
    return http.post({
      url: '/admin/workorder/freeze_withdraw',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  reset(data){
    return http.post({
      url:'/admin/workorder/reset_withdraw',
      data:data,
      dataType: 'form'
    })
  },
  cancel(data) {
    return http.post({
      url: '/admin/workorder/cancel_withdraw',
      data: data,
      dataType: 'form'
    });
  },
  cancelTwoWithdraw(data) {
      return http.post({
          url: '/admin/workorder/cancel_two_withdraw',
          data: data,
          dataType: 'form'
      });
  },
  sendTheWithdrawalTrans(data) {
    return http.post({
      url: '/admin/workorder/handed_network_withdraw',
      data: {
        networkId: data.transId,
        id: data.id
      },
      dataType: 'form'
    });
  },
  getUserWallet(id) {
    return http.get({
      url: '/admin/workorder/findByUse/wallet',
      data: {
        userId: id
      }
    });
  },
  getRebateAmount(data) {
    return http.get({
      url: '/admin/workorder/findByUse/inviteRewards',
      data
    });
  },
  remark(data) {
    return http.get({
      url: '/admin/workorder/add/remark',
      data
    });
  },
  manualConfirm(id) {
    return http.post({
      url: '/admin/workorder/manual_confirm',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  returnToNotApproved(id) {
    return http.post({
      url: '/admin/workorder/return_to_not_approved',
      data: {
        id
      },
      dataType: 'form'
    });
  },

  queryBuyMessage(data) {
    return http.get({
      url : '/admin/tradeMessage/buyQuery',
      data
    })
  },

  querySellMessage(data) {
    return http.get({
      url : '/admin/tradeMessage/sellQuery',
      data
    })
  },

  setRecheckAmount(data) {
    return http.post({
      url: '/admin/workorder/recheck/amount/alter',
      data,
      dataType: 'form'
    });
  },

  getRecheckAmount() {
    return http.get({
      url : '/admin/workorder/recheck/amount/get',
    })
  }
};
